import React, { useState, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import firebase from "firebase/app";
import 'firebase/auth';
import swal from 'sweetalert';
import logo from './../rcrm_logo.png';
import './LoginPage.css';

const client_id = typeof process !== 'undefined' && process && process.env ? process.env.REACT_APP_CLIENT_ID : '';

const LoginPage = () => {
  if (document.addEventListener) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    }, false);
  }
  const history = useHistory();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    let isMounted = true;
    // Check if the user is already logged in and redirect to systemcheck if true
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user && isMounted) {
        setCurrentUser(user);
        history.push("/systemcheck"); // Redirect to systemcheck if already logged in
      }
    });

    // Initialize Google Login
    const initGoogleLogin = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id: client_id,
          callback: handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("buttonDiv"),
          { theme: "outline", size: "large" }
        );

        window.google.accounts.id.prompt();
      } else {
      }
    };

    // Callback for handling credential response
    const handleCredentialResponse = (response) => {
      const idToken = response.credential;
      const credential = firebase.auth.GoogleAuthProvider.credential(idToken);

      firebase.auth().signInWithCredential(credential).then((result) => {
        if (!isMounted) return;
        const user = result.user;
        const userName = user.displayName; // Get user's name
        const userEmail = user.email; // Get user's email

        // Clear all sessionStorage for fresh login

        sessionStorage.clear();

        // Store user details in session storage
        sessionStorage.setItem("checkname", userName);
        sessionStorage.setItem("checkemail", userEmail);

        // Set user and redirect to systemcheck
        setCurrentUser(user);
        history.push("/systemcheck");
      }).catch((error) => {
        if (!isMounted) return;
        swal("Login Failed", "Please try again", "error");
      });
    };

    // Ensure Google Login is initialized when the component mounts
    initGoogleLogin();

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [history]);

  // Redirect if user is already logged in
  if (currentUser) {
    return <Redirect to="/systemcheck" />;
  }

  return (
    <div className="App">
      <img src={logo} alt="logo" className="App-logo" />
      <div className="login-container">
        <div className="login-form">
          <h1 className="login-title">Welcome To RecruitCRM</h1>
          <p className="login-description">Login With Your Gmail account</p>
          <div id="buttonDiv"></div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
